var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as chainables from "./ChainableTypes";
export function chain(fn, omitChainables) {
    if (omitChainables === void 0) { omitChainables = []; }
    Object.keys(chainables).forEach(function (chainName) {
        var chainObj = chainables[chainName];
        var chainFunc = chainObj.func;
        var chainIsFactory = chainObj.isFactory === true;
        if (omitChainables.indexOf(chainName) > -1) {
            return;
        }
        Object.defineProperty(fn, chainName, {
            get: function () {
                if (chainIsFactory) {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return chain(function (value) {
                            var nextValue = chainFunc.apply(void 0, __spreadArray([value], args, false));
                            return fn(nextValue);
                        });
                    };
                }
                return chain(function (value) {
                    var nextValue = value;
                    nextValue = chainFunc(nextValue);
                    nextValue = fn(nextValue);
                    return nextValue;
                }, omitChainables.concat([chainName]));
            },
        });
    });
    return fn;
}
//# sourceMappingURL=chainType.js.map